// Funksjon for å finne tallet og tekst i "big-number"
const extractNumberAndText = (text) => {
    const match = text.match(/([\d,]+)(\s?[^\d]*)/);  // Finn nummer og tekst etter det
    if (match) {
        return {
            number: parseInt(match[1].replace(',', ''), 10), // Fjern komma og konverter til tall
            suffix: match[2] || "" // Behold eventuelle suffikser (som % eller andre enheter)
        };
    }
    return { number: null, suffix: text }; // Hvis det ikke er tall, returner hele teksten
};

// Funksjon for å starte tellingen på tallet
const startCounting = (bigNumber) => {
    const textContent = bigNumber.innerText.trim();
    const { number, suffix } = extractNumberAndText(textContent);

    if (number !== null) {
        let currentCount = 0;
        const interval = number < 1000 ? 100 : (number < 10000 ? 50 : 25); // Dynamisk intervall basert på tallet
        const increment = number / (2000 / interval); // For å få en jevn telling på 2 sekunder

        // Funksjon for å oppdatere tellingen
        const updateCount = () => {
            if (currentCount < number) {
                currentCount += increment;
                bigNumber.innerText = Math.floor(currentCount).toLocaleString() + suffix; // Legg til suffikset
                setTimeout(updateCount, interval);
            } else {
                bigNumber.innerText = number.toLocaleString() + suffix; // Juster til målet og legg til suffikset
            }
        };

        updateCount();
    }
}

// Funksjon for å håndtere fade-in logikk og start tellingen når elementet blir synlig
const handleFadeInElement = (element) => {
    const windowHeight = window.innerHeight;
    const elementTop = element.getBoundingClientRect().top;
    const elementHeight = element.getBoundingClientRect().height;
    let elementVisible = 128;

    if (element.classList.contains('delay-transition')) {
        elementVisible = elementHeight;
    }

    if (elementTop < windowHeight - elementVisible) {
        element.classList.add("active");
        element.classList.remove("inactive");

        if (!element.hasAttribute('data-counting-started')) {
            // Finn tallet i big-number og start telling
            const bigNumber = element.querySelector('.big-number');
            if (bigNumber) {
                startCounting(bigNumber);
            }
            element.setAttribute('data-counting-started', 'true'); // For å unngå dobbeltelling
        }
    } else {
        element.classList.add("inactive");
        element.classList.remove("active");
        element.removeAttribute('data-counting-started'); // For å starte tellingen på nytt
    }
}

// Funksjon for å håndtere scroll og fade-in på elementene
const handleScroll = () => {
    const slideInElements = document.querySelectorAll(".fade-in");

    for (let i = 0; i < slideInElements.length; i++) {
        handleFadeInElement(slideInElements[i]);
    }
}

window.addEventListener("scroll", handleScroll);

// Funksjon for å scroll til toppen
window.scrollToTop = () => {
    window.scrollTo(0, 0);
}

// Funksjon for å scroll til et spesifikt element
window.scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        window.testElement = element;
        const topOffset = 128;
        const elementPosition = element.getBoundingClientRect().top;

        window.scrollBy({
            top: elementPosition - topOffset,
            behavior: "smooth"
        });
    }
}
